import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import moment from "moment";
import axios from "axios";

export const ActualizarPagosWeb = (props) => {
  /* variables de estados */
  const btnCancela = useRef();
  const btnAcpta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(localStorage.getItem("fechasistema"));
  const cmbCuentaBan = useRef("");
  const txtNumDocumento = useRef();
  const [tipoimpu, setTipoimpu] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [desde, setDesde] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [idCtaBanco, setIdCtaBanco] = useState(0);
  const txtFecha = useRef();
  
  // ESTADOS PARA EL MONTO
  const [monto, setMonto] = useState(0); // Valor numérico real para el backend
  const [montoFormateado, setMontoFormateado] = useState(""); // Valor visual con formato
  
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../modulos/datos");

  // --- FUNCIONES EXCLUSIVAS PARA EL FORMATO DEL MONTO ---
  const formatearMonto = (valor) => {
    // 1. Eliminar todo lo que no sea número (puntos, comas, letras)
    const soloNumeros = valor.replace(/\D/g, "");
    if (!soloNumeros) return "";

    // 2. Convertir a número dividiendo por 100 (los últimos 2 dígitos serán los decimales)
    const numero = parseFloat(soloNumeros) / 100;

    // 3. Formatear: punto para miles, coma para decimales (locale 'de-DE' logra exactamente este formato)
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numero);
  };

  const handleMontoChange = (e) => {
    const valor = e.target.value;
    const formateado = formatearMonto(valor);
    
    setMontoFormateado(formateado);
    
    // Guardar el valor numérico real (ej: 1234.56) para enviarlo al backend
    const soloNumeros = valor.replace(/\D/g, "");
    setMonto(soloNumeros ? parseFloat(soloNumeros) / 100 : 0);
  };
  // --------------------------------------------------------

  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/industria/cambiardatospagoweb`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          setActivate(false);
          if (response.data) {
            setDesde(3);
            setTitulo("Confirmación");
            setMsg("Se Generaron Cambios Satisfactoriamente en el Pago Web.");
            setMostrar(true);
          }
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setContar(0);
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo2("");
    setMsg2("");
    setActivate(false);
    setDesde(0);
    setMonto(0);
    setMontoFormateado(""); // Limpiar monto al cerrar
  };

  const handleCloseSi = () => {
    setMostrar1(false);
    console.log(props.data);
    setContar(0);
    let body = {
      fec: txtFecha.current.value,
      idcta: cmbCuentaBan.current.value === "" || cmbCuentaBan.current.value === "0"
          ? props.data.idcuentabanco
          : cmbCuentaBan.current.value,
      idpago: props.data ? (props.data.idpagoweb !== null ? parseInt(props.data.idpagoweb) : "0") : "0",
      numdoc: txtNumDocumento.current.value.trim().toUpperCase(),
      tipo: props.tipopago,
      numtran: props.data ? (props.data.numtran !== null ? parseInt(props.data.numtran) : 0) : 0,
      monto: monto, // Se envía el valor numérico real (ej: 1500.50)
    };
    procesarCambio(body);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
    setDesde(2);
    setTitulo("Confirmación");
    setMsg("No se Generaron Cambios en el Pago Web.");
    setMostrar(true);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
    if (desde === 3) {
      props.onHideAcepta();
    } else if (desde === 2) {
      props.onHideCancela();
    }
    setDesde(0);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    if (obj) setFechaSistema(obj.fechasistema);
    if (props.idcuntabanco) {
      setIdCtaBanco(props.idcuntabanco);
    }
  }, [props.idcuntabanco]);

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputNumDocumento") {
        txtFecha.current.focus();
      } else if (event.target.id === "inputFecha") {
        if (txtFecha.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
        } else {
          cmbCuentaBan.current.focus();
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputFecha") {
        if (txtFecha.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = () => {
    var sigue = true;
    setDesde(0);
    if (txtNumDocumento.current.value.trim() === "" || txtNumDocumento.current.value.trim() === "0") {
      setTitulo("Error");
      setMsg("Debe suministrar el número del documento.");
      setMostrar(true);
      txtNumDocumento.current.focus();
      sigue = false;
    } else if (txtFecha.current.value === "") {
      setTitulo("Error");
      setMsg("Fecha Invalida");
      setMostrar(true);
      sigue = false;
      txtFecha.current.focus();
    } else if (cmbCuentaBan.current.value.trim() === "0" || cmbCuentaBan.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Debe suministrar la cuenta bancaria.");
      setMostrar(true);
      cmbCuentaBan.current.focus();
      sigue = false;
    } else if (monto <= 0) {
      setTitulo("Error");
      setMsg("Debe suministrar un monto válido mayor a 0.");
      setMostrar(true);
      sigue = false;
    }
    
    if (sigue) {
      setDesde(1);
      setTitulo2("Advertencia");
      setMsg2("¿Está Seguro de Cambiar los Datos del Pago Web?");
      setMostrar1(true);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ backgroundColor: "rgb(28, 27, 23, 0.5)" }}
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        // Inicializar monto real y su formato visual al abrir el modal
        const montoInicial = props.data?.monto || 0;
        setMonto(montoInicial);
        
        // Convertimos el monto a "centavos" en string para que el formateador lo procese correctamente
        const centavos = Math.round(montoInicial * 100).toString();
        setMontoFormateado(formatearMonto(centavos));

        txtNumDocumento.current.value = props.data?.nrodocumento ? props.data.nrodocumento.trim() : "";
        txtFecha.current.value = props.data?.fecha ? moment.utc(props.data.fecha).format("YYYY-MM-DD") : "";
        cmbCuentaBan.current.value = props.data?.idcuentabancaria ? parseInt(props.data.idcuentabancaria) : 0;
        txtNumDocumento.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant modal-header">
        {operacion === 1 ? "Agregar Ejercicio Fiscal." :
         operacion === 2 ? "Editar Ejercicio Fiscal." :
         operacion === 3 ? "Eliminar Ejercicio Fiscal." : "Consultar Ejercicio Fiscal."}
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="fas fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje titulo={titulo} mensaje={msg} show={mostrar} onHide={handleCloseMensa} />
        <MensajeSiNo titulo={titulo2} mensaje={msg2} show={mostrar1} onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
        <Dimmer active={activate} inverted></Dimmer>
        
        <div className="row mx-auto">
          <h2 className="text-center">Introduzca Nuevos Datos</h2>

          <div className="input-group input-group-sm mb-2 col-md-8">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">Documento:</span>
            </div>
            <input
              type="text"
              name="codigo"
              ref={txtNumDocumento}
              className="form-control form-control-sm"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              id="inputNumDocumento"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">Fecha:</span>
            </div>
            <input
              type="date"
              className="form-control form-control-sm"
              ref={txtFecha}
              id="inputFecha"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-8">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">Cuenta:</span>
            </div>
            <select
              name=""
              ref={cmbCuentaBan}
              defaultValue={"0"}
              className="form-control form-control-sm"
            >
              <option key="0" value="0">--Seleccione--</option>
              {props.cuentabancaria &&
                props.cuentabancaria.map((cta) => (
                  <option key={cta.idcuentabancaria} value={cta.idcuentabancaria}>
                    {cta.nombre + " " + cta.cuentabancaria}
                  </option>
                ))}
            </select>
          </div>

          {/* CAMPO DE MONTO CON FORMATO DINÁMICO */}
          <div className="input-group input-group-sm mb-2 col-md-4">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">Monto:</span>
            </div>
            <input
              type="text"
              name="monto"
              className="form-control form-control-sm"
              value={montoFormateado}
              onChange={handleMontoChange}
              placeholder="0,00"
              style={{ textAlign: "right" }} // Opcional: alinea el número a la derecha para mejor lectura
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button ref={btnAcpta} onClick={onChangeValidar} className="btn btn-sm btn-success rounded-pill">
          <i className="fas fa-check-circle"></i> Aceptar
        </button>
        <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill">
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};  